import { RenderableGroup } from './renderable-group';

export class RenderablePageGroup extends RenderableGroup {
}
